import { render, staticRenderFns } from "./FormAssetDescription.vue?vue&type=template&id=4dd719fb"
import script from "./FormAssetDescription.vue?vue&type=script&lang=js"
export * from "./FormAssetDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports